import React, { useEffect, useState, useRef, ChangeEvent, JSX } from 'react'
import { AppBar, useTheme, TextField, Chip, Button } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import { withStyles, createStyles } from '@mui/styles';
import { Divide as Hamburger } from 'hamburger-react'
import { Link, useHistory } from 'react-router-dom';
import GutermannLogo from '../../assets/gutermann/gutermann-white.png'
import { ReactComponent as AshLogo } from '../../assets/ashLogo.svg';
import SearchIcon from '@mui/icons-material/Search';
import SlideInAnimation from '../../Animation Wrappers/SlideInAnimation';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import FullWidthMobileButton from '../FullWidthMobileButton';
import { User } from '../../models/UserModel'
import { APIGetLoggersModel } from '../../models/APIGetLoggersModel'
import { isLCLLogger } from 'variables/chariotProductIds';
import { useMobileLandscape, useTabletContext } from '../../Context/ContextProvider'
import Search from '../../components/Search/Search'
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
interface Props {
    handleDrawerToggle: (e: React.MouseEvent) => void
    open: boolean
    impersonateUser: string
    user: User
    deviceData: Array<APIGetLoggersModel>
}


const style = createStyles(styles);



const NavBarMobile: React.FC<Props> = ({ handleDrawerToggle, open, impersonateUser, user, deviceData }) => {
    const intl: IntlShape = useIntl()
    const useStyles = makeStyles(styles);
    const theme = useTheme()
    const classes = useStyles();
    const searchRef = useRef(null)
    const textInputRef = useRef(null)
    const history = useHistory()
    const isLandscape = useMobileLandscape()
    const isTablet = useTabletContext()
    //state 
    const [searchOpen, setSearchOpen] = useState<boolean>(false)
    const [showImpersonateDetails, setShowImpersonateDetails] = useState<boolean>(false)
    //const [searchContent, setSearchContent] = useState<string>("")
    //const [searchDisplayText, setSearchDisplayText] = useState<string>("")
    //const [searchResults, setSearchResults] = useState<Array<APIGetLoggersModel> | null>([])



    //const handleSearchClick = () => {
    //    setSearchOpen(!searchOpen)
    //}

    const handleImpersonateClick = () => {
        setShowImpersonateDetails(!showImpersonateDetails)
    }


    const endImpersonation = ():void => {
        window.sessionStorage.removeItem('impersonateUser');
        window.sessionStorage.removeItem('impersonateCompany');

        // Restore identityadmin details
        window.sessionStorage.setItem('companyId', '0');
        window.sessionStorage.setItem('companyGuid', user.company.toString());
        window.sessionStorage.setItem('userId', '0');
        window.sessionStorage.setItem('userLevel', user.userlevel);
        window.sessionStorage.setItem('userGuid', user.sub.toString());
        window.sessionStorage.setItem('filterGroupId', '0');
        window.sessionStorage.setItem('companyName', "Ashridge");
        window.sessionStorage.setItem("utcOffset", "0");
        window.sessionStorage.setItem("inactiveTimeframe", "24 Hours");
        window.sessionStorage.setItem("graphTotaliser", "true")
        window.sessionStorage.setItem("language", 'en-GB')
        // Reload to update navbar
        window.location.href = '/portal/dashboard';
    }

    return (
        <div>
        <AppBar className={classes.appBar} style={{ height: "50px" }}>
            <div style={{ margin: "0 10px", display: "flex", justifyContent: "space-between" }}>
                <Hamburger color={'#ffffff'} size={40} distance="md" easing="ease-in" duration={0.1} rounded toggle={handleDrawerToggle} toggled={open} />
                {impersonateUser && <div onClick={(): void => handleImpersonateClick()} style={{ position: "relative" }}>
                    <SupervisorAccountIcon fontSize="large" style={{ margin: "5px 5px 0 5px" }} color="primary" />
                    {showImpersonateDetails &&
                        <SlideInAnimation direction="top" duration={0.8} delay={0.2} transitionAmount={50} isVisible={showImpersonateDetails}>
                            <div style={{
                                position: 'absolute',
                                background: "white",
                                width: "90vw",
                                transform: "translateX(-34vw)",
                                marginTop: "20px",
                                border: "1px solid black",
                                borderRadius: 5,
                                padding: "10px 5px 5px 5px"
                            }}>
                                <p style={{ textAlign: "center" }}><FormattedMessage id='Impersonating'/>: <b>{impersonateUser}</b></p>
                                <div style={{ padding: "0 10px 10px 10px" }}>
                                        <FullWidthMobileButton disabled={false} color="warning" text={intl.formatMessage({ id: 'End Impersonation' })} onClick={(): void => endImpersonation()} />
                                </div>
                            </div>
                        </SlideInAnimation>
                    }
                </div>}
                    <div style={{ display: "flex" }}>
                        <Search deviceData={deviceData} />                    
                        <Link to="/portal/dashboard">
                            {window.location.hostname.includes('zonelog.net') ? <img src={GutermannLogo} style={{ width: "30px", height: "40px", margin: "4px 0 0 0" }} /> : <AshLogo style={{ width: "48px", height: "48px" }} />}
                        </Link>
                </div>
            </div>
        </AppBar>
        </div>
    )
}
export default withStyles(style)(NavBarMobile)